"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRRule = void 0;
const rrule_1 = require("rrule");
const ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function isValidDate(m) {
    return !Number.isNaN(m.valueOf());
}
function parseMarker(str) {
    const m = ISO_RE.exec(str);
    if (m) {
        const marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if (isValidDate(marker)) {
            let timeZoneOffset = null;
            if (m[13]) {
                timeZoneOffset =
                    (m[15] === '-' ? -1 : 1) *
                        (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            }
            return {
                marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset,
            };
        }
    }
    return null;
}
function convertConstants(input) {
    if (Array.isArray(input)) {
        return input.map(convertConstant);
    }
    return convertConstant(input);
}
function convertConstant(input) {
    if (typeof input === 'string') {
        return rrule_1.RRule[input.toUpperCase()];
    }
    return input;
}
const parseRRule = ({ rrule }) => {
    try {
        let isTimeSpecified = false;
        let isTimeZoneSpecified = false;
        const processDateInput = (dateInput) => {
            if (typeof dateInput === 'string') {
                const markerData = parseMarker(dateInput);
                if (markerData) {
                    isTimeSpecified = isTimeSpecified || !markerData.isTimeUnspecified;
                    isTimeZoneSpecified =
                        isTimeZoneSpecified || markerData.timeZoneOffset !== null;
                    return new Date(markerData.marker.valueOf() -
                        (markerData.timeZoneOffset || 0) * 60 * 1000); // NOT DRY
                }
                return null;
            }
            return dateInput;
        };
        const rruleOptions = {
            ...rrule,
            dtstart: processDateInput(rrule.dtstart),
            until: processDateInput(rrule.until),
            freq: convertConstant(rrule.freq),
            wkst: rrule.wkst == null ? rrule_1.RRule.MO : convertConstant(rrule.wkst),
            byweekday: convertConstants(rrule.byweekday),
        };
        return {
            rrule: new rrule_1.RRule(rruleOptions),
            isTimeSpecified,
            isTimeZoneSpecified,
        };
    }
    catch (ex) {
        console.error('parseRRule::exception::', ex);
        return null;
    }
};
exports.parseRRule = parseRRule;
